'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import ScrollSectionTabs from '@/components/common/ScrollSectionTabs';
import { useWeb3Context } from '@/contexts/Web3Context';
import { useTrackTabChanged } from '@/lib/analytics/client/hooks/useTrackTabChanged';
import { getVisibleOptions, type MarketSubTabs } from './useMarketSubTabState';
export interface MarketTabsProps {
  marketSlots: ReactNode;
  ratesSlots: ReactNode;
  riskSlots: ReactNode;
  activitySlots: ReactNode;
  yourPositionSlots: ReactNode;
}
export default function MarketTabs(t0) {
  const $ = _c(22);
  const {
    marketSlots,
    ratesSlots,
    riskSlots,
    activitySlots,
    yourPositionSlots
  } = t0;
  const {
    account: t1
  } = useWeb3Context();
  const {
    isConnected
  } = t1;
  let t2;
  if ($[0] !== isConnected) {
    t2 = getVisibleOptions(isConnected);
    $[0] = isConnected;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const options = t2;
  const trackTabChanged = useTrackTabChanged("market");
  let t3;
  if ($[2] !== marketSlots) {
    t3 = {
      id: "market",
      label: "Market",
      slot: marketSlots
    };
    $[2] = marketSlots;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== ratesSlots) {
    t4 = {
      id: "rates",
      label: "Rates",
      slot: ratesSlots
    };
    $[4] = ratesSlots;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== riskSlots) {
    t5 = {
      id: "risk",
      label: "Risk",
      slot: riskSlots
    };
    $[6] = riskSlots;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== activitySlots) {
    t6 = {
      id: "activity",
      label: "Activity",
      slot: activitySlots
    };
    $[8] = activitySlots;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== yourPositionSlots) {
    t7 = {
      id: "yourPosition",
      label: "Your Position",
      slot: yourPositionSlots,
      requiresConnectedWallet: true
    };
    $[10] = yourPositionSlots;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = [t3, t4, t5, t6, t7];
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== options || $[19] !== t8 || $[20] !== trackTabChanged) {
    t9 = <ScrollSectionTabs segmentId="market-overview-segment" dataTestId="market-tabs" onTabChange={trackTabChanged} defaultSectionId="market" fallbackSectionId="activity" yourPositionSectionId="yourPosition" options={options} sections={t8} />;
    $[18] = options;
    $[19] = t8;
    $[20] = trackTabChanged;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}